module.exports = __webpack_public_path__ + "img/customer_design_6@2x.1c5870a.jpg";